var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page-with-top-bar"},[_c('project-admin-quick-buttons',{attrs:{"hiddenOption":"permitting"}}),_vm._v(" "),_c('div',[_c('manage-permitting',{ref:"manage_permitting",attrs:{"projectId":_vm.project_id,"company":_vm.company.id},on:{"reload-list":_vm.handleReloadPermitting}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }